import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  labelRow: {
    display: 'flex',
    alignItems: 'center'
  },
  helpButton: {
    padding: theme.spacing(1),
    marginLeft: theme.spacing(0.5)
  },
  helpIcon: {
    width: 14,
    height: 14
  }
}));
